
import Vue from 'vue';
import { Component, Vue as VueComponent } from 'vue-property-decorator';
import DescriptionField from '../components/private/formcomponents/DescriptionField.vue';
import TextField from '../components/private/formcomponents/TextField.vue';
import IntegerField from '../components/private/formcomponents/IntegerField.vue';
import DecimalField from '../components/private/formcomponents/DecimalField.vue';
import ComboField from '../components/private/formcomponents/ComboField.vue';
import TextAreaField from '../components/private/formcomponents/TextAreaField.vue';
import DateAndTimeField from '../components/private/formcomponents/DateAndTimeField.vue';
import CheckField from '../components/private/formcomponents/CheckField.vue';
import FileField from '../components/private/formcomponents/FileField.vue';
import SQLInputField from '../components/private/formcomponents/SQLInputField.vue';
import FieldsetWrap from '../components/private/formcomponents/FieldsetWrap.vue';
import TitleField from '../components/private/formcomponents/TitleField.vue';

@Component
export default class GlobalComponents extends VueComponent {
  constructor() {
    super();
    this.registerComponents();
  }

  private registerComponents() {
    const components = {
      DescriptionField,
      TextField,
      IntegerField,
      DecimalField,
      ComboField,
      TextAreaField,
      DateAndTimeField,
      CheckField,
      FileField,
      SQLInputField,
      FieldsetWrap,
      TitleField
    };

    Object.entries(components).forEach(([name, component]) => {
      Vue.component(name, component);
    });
  }
}
